<template>
  <div class="">
    <template v-if="type == 'signup'">
      <PCSignUp />
    </template>
    <template v-else>
      <PCLogin />
    </template>
  </div>
</template>

<script>
import PCSignUp from "./signup/pc.vue";
import PCLogin from "./login/pc.vue";

export default {
  components: {
    PCSignUp,
    PCLogin,
  },
  data() {
    return {};
  },
  computed: {
    type() {
      return this.$route.name
    }
  },
  beforeCreate() {
  },
};
</script>

<style lang="scss" scoped>
</style>